module.exports = __webpack_public_path__ + "img/hover_zh.3c4864b4.png";